import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/base/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/common/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./template/layout/layout.module').then((m) => m.LayoutModule),
  },
  {
    path: 'stores/:id',
    loadChildren: () =>
      import('./modules/base/landing-pages/landing-pages.module').then((m) => m.LandingPageModule),
  },
  {
    path: 'stores/:id/downloads',
    loadChildren: () =>
      import('./modules/base/landing-pages-new/landing-pages-new.module').then((m) => m.LandingPagesNewModule),
  },
  {
    path: 'downloads-nailworks',
    loadChildren: () =>
      import('./modules/base/landing-pages-nailwork/landing-pages-nailwork.module').then((m) => m.LandingPagesNailWorkModule),
  },
  {
    path: ':id/downloads-supplies',
    loadChildren: () =>
      import('./modules/base/landing-pages-nailsupply/landing-pages-nailsupply.module').then((m) => m.LandingPagesNailSupplyModule),
  },
  {
    path: 'booking',
    loadChildren: () =>
      import('./modules/base/bookings/booking.module').then((m) => m.BookingModule),
  },
  {
    path: 'buy-gift-card',
    loadChildren: () =>
      import('./modules/base/buy-gift-cards/buy-gift-card.module').then((m) => m.BuyGiftCardModule),
  },
  {
    path: 'appointments',
    loadChildren: () =>
      import('./modules/base/appointments/appointment.module').then((m) => m.AppointmentModule),
  },
  {
    path: 'display-voucher',
    loadChildren: () =>
      import('./modules/base/display-vouchers/display-voucher.module').then((m) => m.DisplayVoucherModule),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
